import paQuickQuoteView from 'text!../views/pa-quick-quote.html';
import PaQuickQuoteCtrl from '../controllers/PaQuickQuoteCtrl';

export default (RootStates) => {
    const parentState = RootStates.quote_bind;

    return {
        paquickQuote: {
            parent: parentState,
            url: '/paquickQuote',
            controller: PaQuickQuoteCtrl,
            template: paQuickQuoteView,
            data: {
                trackingUrl: '/pa-quick-quote/PersonalAuto'
            }
        }
    };
};
